<div class="dashboard-grid-layout">
  <div #gridArea class="dashboard-grid" [style.--dashboard-grid-min-width.px]="editingMinWidth()">
    <div class="dashboard-grid__toolbar">
      <div class="dashboard-grid__heading">
        <ng-content select="[dashboardTitle]" />
        <p class="dashboard-grid__subtitle">
          <ng-content select="[dashboardSubtitle]" />
          @for (label of filterSummary(); track $index) {
            <span class="dashboard-grid__subtitle-item">{{ label }}</span>
          }
        </p>
      </div>

      <div class="dashboard-grid__actions">
        <p class="dashboard-grid__meta">
          <mat-icon
            class="dashboard-grid__meta-icon"
            [class.dashboard-grid__meta-icon--on]="refresh()?.enabled"
            aria-hidden="true">
            autorenew
          </mat-icon>
          <span>{{
            'Dashboard.Updated' | translate: locale.language : { time: context.lastUpdated() | date: 'shortTime' }
          }}</span>
          @if (refresh()?.enabled) {
            <span class="dashboard-grid__meta-item">
              {{ 'Dashboard.AutoRefresh' | translate: locale.language : { interval: refreshLabel() } }}
            </span>
          }
        </p>
        @if (!session.editing() && !isMobile() && session.layout()) {
          <button
            #customizeButton
            mat-flat-button
            color="primary"
            type="button"
            class="dashboard-grid__customize"
            (click)="customize()">
            <mat-icon>dashboard_customize</mat-icon>
            {{ 'Dashboard.Customize' | translate: locale.language }}
          </button>
        }
      </div>
    </div>

    @if (filterFields().length) {
      <mat-card
        appearance="outlined"
        class="dashboard-grid__filters"
        role="group"
        [attr.aria-label]="'Dashboard.Filters' | translate: locale.language">
        <mat-card-content class="dashboard-grid__filters-content">
          @for (field of filterFields(); track field.name) {
            @if (field.filter; as filter) {
              @switch (filter.control) {
                @case ('toggle') {
                  <mat-button-toggle-group
                    class="dashboard-grid__toggle"
                    hideSingleSelectionIndicator
                    [attr.aria-label]="filter.label | translate: locale.language"
                    [value]="context.valueOf(field.name)()"
                    (change)="context.setValue(field.name, $event.value)">
                    @for (option of filter.options; track $index) {
                      <mat-button-toggle [value]="option.value">
                        {{ option.label | translate: locale.language }}
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>
                }
                @case ('select') {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dashboard-grid__select">
                    <mat-label>{{ filter.label | translate: locale.language }}</mat-label>
                    <mat-select
                      [value]="context.valueOf(field.name)()"
                      (selectionChange)="context.setValue(field.name, $event.value)">
                      @for (option of filter.options; track $index) {
                        <mat-option [value]="option.value">{{ option.label | translate: locale.language }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              }
            }
          }

          <button mat-button type="button" class="dashboard-grid__reset-filters" (click)="context.resetFilters()">
            {{ 'Dashboard.ResetFilters' | translate: locale.language }}
          </button>
        </mat-card-content>
      </mat-card>
    }

    @if (session.layout()) {
      @if (!session.visibleWidgets().length) {
        <p class="dashboard-grid__status">
          @if (session.editing()) {
            {{ 'Dashboard.AddWidgetToStart' | translate: locale.language }}
          } @else {
            {{ 'Dashboard.NoWidgets' | translate: locale.language }}
          }
        </p>
      }

      <div class="dashboard-grid__canvas-scroll">
        <app-dashboard-grid-canvas
          [style.min-width.px]="editingMinWidth()"
          [widgets]="session.visibleWidgets()"
          [sizeLimits]="sizeLimits"
          [editing]="session.editing()"
          [grid]="grid"
          [stacked]="stacked()"
          (arranged)="arranged($event)">
          <ng-template dashboardGridItem let-widget>
            <app-dashboard-widget-frame
              [instance]="widget"
              [definition]="definitionOf(widget)"
              [editing]="session.editing()"
              (removeRequested)="removeWidget(widget.id)"
              (settingsRequested)="editSettings(widget)"
              (moveRequested)="moveWidget(widget.id, $event)"
              (resizeRequested)="resizeWidget(widget.id, $event)" />
          </ng-template>
        </app-dashboard-grid-canvas>
      </div>
    } @else {
      <output class="dashboard-grid__status">{{ 'Dashboard.Loading' | translate: locale.language }}</output>
    }
  </div>

  @if (session.editing()) {
    <app-dashboard-customize-panel />
  }
</div>
